/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement, useState } from 'react';
import { useParams } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import LoginComponent from '../components/AccountActivation/login';
import RegisterDeviceComponent from '../components/AccountActivation/register-device';
import UserDetailsComponent from '../components/AccountActivation/user-details';
import LinkSentComponent from '../components/AccountActivation/link-sent';
import OrganisationSetupComponent from '../components/AccountActivation/organisation-setup';
import AuthHeader from '../components/AccountActivation/header';
import ForgotPasswordComponent from '../components/AccountActivation/forgotPassword';
import VerifyOtpComponent from '../components/AccountActivation/verify-otp';
import ResetPasswordComponent from '../components/AccountActivation/resetPassword';
import ResetTempPasswordComponent from '../components/AccountActivation/resetTempPassword';

const banner = {
  img: '/assets/telosair_monitor.png',
  title: 'Air Quality Monitoring',
  subtitle: 'At the palm of your hand',
  path: '/',
  id: 1
};

/**
 * Login component for user authentication.
 * @returns  A React element representing the Login component.
 */
export default function AuthenticationAndActivation(): ReactElement {
  const param = useParams();
  const [currentPage, setCurrentPage] = useState(0);

  /**
   * Function to get component by type parameter.
   * @returns - Recat component.
   */
  const getComponentByType = (): ReactElement => {
    switch (param.type) {
      case 'register-device': {
        return <RegisterDeviceComponent />;
      }
      case 'user-details': {
        return <UserDetailsComponent />;
      }
      case 'link-sent': {
        return <LinkSentComponent />;
      }
      case 'verify-otp': {
        return <VerifyOtpComponent />;
      }
      case 'organisation-setup': {
        return <OrganisationSetupComponent />;
      }
      case 'forgot-password': {
        return <ForgotPasswordComponent />;
      }
      case 'reset-password': {
        return <ResetPasswordComponent />;
      }
      case 'set-temporary-password': {
        return <ResetTempPasswordComponent />;
      }
      default: {
        return <LoginComponent />;
      }
    }
  };

  return (
    <div className="h-screen overflow-hidden relative">
      <div className="flex flex-col h-full justify-between">
        <AuthHeader />
        <div className="container mx-auto grid grid-cols-12 gap-4">
          <div className="col-span-5 col-start-2 h-full hidden md:block">
            <div className="border-4 rounded-lg border-container-700 h-full bg-background-700">
              <div className="px-8 py-6 h-full" key={banner.id}>
                <div>
                  <div className="text-xl font-semibold dark:text-white text-black">
                    {banner.title}
                  </div>
                  <div className="font-semibold text-primary-500 mt-1">{banner.subtitle}</div>
                </div>
                <div className="!flex flex-col justify-center items-center h-full">
                  <img src={banner.img} alt={`${banner.title} banner`} className="object-center" />
                </div>
              </div>
            </div>
          </div>
          <div className="md:col-span-4 col-span-10 col-start-2 md:col-start-8 flex justify-center items-center">
            {getComponentByType()}
          </div>
        </div>
        <footer className="bg-white dark:bg-background-700 flex items-center py-3 px-8 justify-between text-xs text-white">
          <div className="flex items-center gap-11">
            <div>&bull; Terms of service</div>
            <div>&bull; Privacy policy</div>
          </div>
          <div>V1.01</div>
        </footer>
      </div>
    </div>
  );
}
